import { render, staticRenderFns } from "./SmLeaderboard.vue?vue&type=template&id=ef443ef0&scoped=true&"
import script from "./SmLeaderboard.vue?vue&type=script&lang=js&"
export * from "./SmLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./SmLeaderboard.vue?vue&type=style&index=0&id=ef443ef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef443ef0",
  null
  
)

export default component.exports